/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import FilterTranslated from '../../../components/filter/FilterTranslated';
import FilterStatus from '../../../components/filter/FilterStatus';
import TATypeFilter from '../filters/TATypeFilter';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemStatus,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';
import moment from 'moment';
import DateFilter from '../../../components/filter/FilterDate';
import TASourceFilter from '../filters/TASourceFilter';

const type_id_to_label = {
  1: "Buy", // offer
  2: "Buy", // store
  3: "Tap", // offer
};
function Row({ row }) {
  const { t } = useLanguageContext();

  let item_type = row.store ? "store" : "offer";
  let item = row.store || row.offer;
  let user_link = row.login_id ? `/user/${row.login_id}` : null;
  return <tr>
    <ContentBodyCheckbox row={row} />
    <ContentBodyItem>{row.id}</ContentBodyItem>
    <ContentBodyItem>{t(type_id_to_label[row.type_id] || "Unknown")}</ContentBodyItem>
    <ContentBodyItem to={`/${item_type}/${item.id}`}>{item.name}</ContentBodyItem>
    <ContentBodyItem>{row.path}</ContentBodyItem>
    <ContentBodyItem to={user_link}>{row.login_id || 'not logged in'}</ContentBodyItem>
    <ContentBodyItem>{moment(row.created_at).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
    <ContentBodyItem></ContentBodyItem>
  </tr>
}
function MobileRow({ row }) {
  const { t } = useLanguageContext();

  let item_type = row.store ? "store" : "offer";
  let item = row.store || row.offer;
  let user_link = row.login_id ? `/user/${row.login_id}` : null;

  return <ContentListRow key={row.id} row={row}>
    <ContentListItem>{row.id}</ContentListItem>
    <ContentListItem>{t(type_id_to_label[row.type_id] || "Unknown")}</ContentListItem>
    <ContentListItem to={`/${item_type}/${item.id}`}>{item.name}</ContentListItem>
    <ContentListItem>{row.path}</ContentListItem>
    <ContentListItem to={user_link}>{row.login_id || 'not logged in'}</ContentListItem>
    <ContentListItem>{moment(row.created_at).format('YYYY-MM-DD HH:mm:ss')}</ContentListItem>
  </ContentListRow>
}
export default function Content() {
  const { t } = useLanguageContext();
  const { listItems, paginator } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['path']} search_label="Search by path">
        <TATypeFilter />
        <TASourceFilter />
        <DateFilter></DateFilter>
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Type')} sortBy="type_id" width={120} />
          <ContentHeaderItem title={t('Item')} />
          <ContentHeaderItem title={t('Path')} />
          <ContentHeaderItem title={t('User ID')} />
          <ContentHeaderItem title={t('Date')} sortBy="created_at" />
          <ContentHeaderItem title={t('Total')} />
        </ContentHeader>

        <ContentBody colspan={7}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (<Row key={row.id} row={row}></Row>))
          ) : null}
          {!!listItems?.length && <tr>
            <ContentBodyItem>{t("Total: ")}</ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem>{paginator.cnt}</ContentBodyItem>
          </tr>}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <MobileRow key={row.id} row={row} />
          ))
        ) : null}
        {!!listItems?.length && <ContentListRow row={{ id: "", no_btns: true }}>
          <ContentListItem>{t("Total: ")} {paginator.cnt}</ContentListItem>
        </ContentListRow>
        }
      </ContentList>

    </Fragment >
  );
}